// How important an "Att göra nu" row is (ClickUp 869fj6nkx). The list shows
// the most important first, each row with a colour and a text label:
//   urgent  = stops the project or the money (red, "Brådskande")
//   waiting = someone else waits for the user's answer (amber, "Väntar på dig")
//   later   = nothing waits for it (blue, "När du har tid")
// Within a level, what has waited longest comes first.

export type TodoPriority = 'urgent' | 'waiting' | 'later';

export const TODO_PRIORITY_ORDER: readonly TodoPriority[] = ['urgent', 'waiting', 'later'];

const rank = (priority: TodoPriority) => TODO_PRIORITY_ORDER.indexOf(priority);
const time = (value: string | null | undefined) => {
  const parsed = value ? Date.parse(value) : NaN;
  return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
};

/**
 * Most important first; within a level the oldest `since` first (rows
 * without a time after those with one), otherwise the input order.
 */
export function sortByPriority<T>(
  items: T[],
  priority: (item: T) => TodoPriority,
  since: (item: T) => string | null | undefined = () => undefined
): T[] {
  return items
    .map((item, index) => ({ item, index }))
    .sort((a, b) =>
      rank(priority(a.item)) - rank(priority(b.item)) ||
      time(since(a.item)) - time(since(b.item)) ||
      a.index - b.index)
    .map(({ item }) => item);
}
